import { apiHelper } from '@/util'

export const facebookPixelService = {
  getFacebookPixels,
  postChannelPageView
}

//API urls
const FACEBOOK = {
  FACEBOOK: 'facebook',
  GET_PIXELS: 'get-pixel',
  CHANNEL: 'channel',
  PAGEVIEW: 'pageview'
}

function getFacebookPixels() {
  return apiHelper().get(`${FACEBOOK.FACEBOOK}/${FACEBOOK.GET_PIXELS}`)
}
function postChannelPageView(channelDbId, { fingerprint, referrer = null }) {
  return apiHelper().post(`${FACEBOOK.CHANNEL}/${channelDbId}/${FACEBOOK.PAGEVIEW}`, {
    fingerprint,
    referrer
  })
}
